import { ocapiV1Routes } from '../routes';
export const seatingApiRoutes = {
    availability: {
        getForShowtime: (showtimeId) => `${ocapiV1Routes.showtimes}/${showtimeId}/seat-availability`,
        getForOrder: (orderId, showtimeId) => `${ocapiV1Routes.orders}/${orderId}/showtimes/${showtimeId}/seat-availability`
    },
    masterData: {
        seatLayout: {
            getById: (seatLayoutId) => `${ocapiV1Routes.prefix}/seat-layouts/${seatLayoutId}`,
            getForShowtime: (showtimeId) => `${ocapiV1Routes.showtimes}/${showtimeId}/seat-layout`
        }
    }
};
//# sourceMappingURL=routes.js.map